import React from 'react';

import HypothesesListScreen from './HypothesesListScreen';

export default class HypothesesRecommendationsScreen extends React.Component {
  render() {
    return <HypothesesListScreen showRecommendations={true} />;
  }
}
